// Geração de .xlsx (Office Open XML) sem dependências externas. Monta um ZIP
// no método "store" (sem compressão) com os XML mínimos que o Excel aceita e
// dispara o download no navegador. Strings vão como inlineStr (dispensa
// sharedStrings.xml); números vão direto. Suficiente para exportar tabelas.

function makeCrcTable() {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
    t[n] = c >>> 0;
  }
  return t;
}
const CRC_TABLE = makeCrcTable();

function crc32(buf) {
  let c = 0xFFFFFFFF;
  for (let i = 0; i < buf.length; i++) c = CRC_TABLE[(c ^ buf[i]) & 0xFF] ^ (c >>> 8);
  return (c ^ 0xFFFFFFFF) >>> 0;
}

const encoder = new TextEncoder();
const bytes = (str) => encoder.encode(str);

// Índice de coluna (0-based) -> letra(s) A, B, ... Z, AA, AB, ...
export function colName(idx) {
  let n = idx + 1;
  let s = '';
  while (n > 0) {
    const m = (n - 1) % 26;
    s = String.fromCharCode(65 + m) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}

function xmlEscape(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

// rows: Array<Array<{ v, t } | null>> — t: 'n' (número) | 's' (string).
// merges: Array<string> — refs A1 tipo "D1:F1" para células mescladas.
function sheetXml(rows, merges) {
  let out = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
    + '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
    + '<sheetData>';
  rows.forEach((row, r) => {
    out += `<row r="${r + 1}">`;
    row.forEach((cell, c) => {
      if (!cell || cell.v === null || cell.v === undefined || cell.v === '') return;
      const ref = colName(c) + (r + 1);
      if (cell.t === 'n') {
        out += `<c r="${ref}"><v>${cell.v}</v></c>`;
      } else {
        out += `<c r="${ref}" t="inlineStr"><is><t xml:space="preserve">${xmlEscape(cell.v)}</t></is></c>`;
      }
    });
    out += '</row>';
  });
  out += '</sheetData>';
  if (merges && merges.length) {
    out += `<mergeCells count="${merges.length}">`;
    merges.forEach(ref => { out += `<mergeCell ref="${xmlEscape(ref)}"/>`; });
    out += '</mergeCells>';
  }
  out += '</worksheet>';
  return out;
}

const CONTENT_TYPES = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
  + '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'
  + '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>'
  + '<Default Extension="xml" ContentType="application/xml"/>'
  + '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>'
  + '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>'
  + '</Types>';

const RELS = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
  + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
  + '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>'
  + '</Relationships>';

const WORKBOOK_RELS = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
  + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
  + '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>'
  + '</Relationships>';

function workbookXml(sheetName) {
  const safe = String(sheetName).replace(/[[\]:*?/\\]/g, ' ').slice(0, 31) || 'Planilha';
  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
    + '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" '
    + 'xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'
    + `<sheets><sheet name="${xmlEscape(safe)}" sheetId="1" r:id="rId1"/></sheets>`
    + '</workbook>';
}

// Monta o ZIP (store) a partir de [{ name, data: Uint8Array }].
function zipStore(files) {
  const chunks = [];
  let offset = 0;
  const push = (arr) => { chunks.push(arr); offset += arr.length; };

  const central = [];
  files.forEach(f => {
    const nameBytes = bytes(f.name);
    const crc = crc32(f.data);
    const size = f.data.length;
    const localOffset = offset;

    const header = new Uint8Array(30 + nameBytes.length);
    const dv = new DataView(header.buffer);
    dv.setUint32(0, 0x04034b50, true);
    dv.setUint16(4, 20, true);
    dv.setUint16(6, 0, true);
    dv.setUint16(8, 0, true);
    dv.setUint16(10, 0, true);
    dv.setUint16(12, 0, true);
    dv.setUint32(14, crc, true);
    dv.setUint32(18, size, true);
    dv.setUint32(22, size, true);
    dv.setUint16(26, nameBytes.length, true);
    dv.setUint16(28, 0, true);
    header.set(nameBytes, 30);
    push(header);
    push(f.data);

    central.push({ nameBytes, crc, size, localOffset });
  });

  const cdStart = offset;
  central.forEach(c => {
    const rec = new Uint8Array(46 + c.nameBytes.length);
    const dv = new DataView(rec.buffer);
    dv.setUint32(0, 0x02014b50, true);
    dv.setUint16(4, 20, true);
    dv.setUint16(6, 20, true);
    dv.setUint16(8, 0, true);
    dv.setUint16(10, 0, true);
    dv.setUint16(12, 0, true);
    dv.setUint16(14, 0, true);
    dv.setUint32(16, c.crc, true);
    dv.setUint32(20, c.size, true);
    dv.setUint32(24, c.size, true);
    dv.setUint16(28, c.nameBytes.length, true);
    dv.setUint16(30, 0, true);
    dv.setUint16(32, 0, true);
    dv.setUint16(34, 0, true);
    dv.setUint16(36, 0, true);
    dv.setUint32(38, 0, true);
    dv.setUint32(42, c.localOffset, true);
    rec.set(c.nameBytes, 46);
    push(rec);
  });
  const cdSize = offset - cdStart;

  const end = new Uint8Array(22);
  const dv = new DataView(end.buffer);
  dv.setUint32(0, 0x06054b50, true);
  dv.setUint16(4, 0, true);
  dv.setUint16(6, 0, true);
  dv.setUint16(8, files.length, true);
  dv.setUint16(10, files.length, true);
  dv.setUint32(12, cdSize, true);
  dv.setUint32(16, cdStart, true);
  dv.setUint16(20, 0, true);
  push(end);

  let total = 0;
  chunks.forEach(c => { total += c.length; });
  const out = new Uint8Array(total);
  let p = 0;
  chunks.forEach(c => { out.set(c, p); p += c.length; });
  return out;
}

// Exporta uma matriz (array de arrays) como .xlsx e dispara o download.
// Números viram células numéricas; o resto vira texto. filename deve terminar
// em .xlsx. merges (opcional): refs A1 tipo "D1:F1" para mesclar células.
export function exportXlsx(filename, sheetName, aoa, merges) {
  const rows = aoa.map(row => row.map(v => {
    if (typeof v === 'number' && Number.isFinite(v)) return { v, t: 'n' };
    if (v === null || v === undefined || v === '') return null;
    return { v: String(v), t: 's' };
  }));

  const files = [
    { name: '[Content_Types].xml', data: bytes(CONTENT_TYPES) },
    { name: '_rels/.rels', data: bytes(RELS) },
    { name: 'xl/workbook.xml', data: bytes(workbookXml(sheetName)) },
    { name: 'xl/_rels/workbook.xml.rels', data: bytes(WORKBOOK_RELS) },
    { name: 'xl/worksheets/sheet1.xml', data: bytes(sheetXml(rows, merges)) }
  ];

  const blob = new Blob([zipStore(files)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
